import React, {useState, Component} from 'react';
import { Nav, Navbar, Button } from 'react-bootstrap';
import {connect} from 'react-redux';
import { Redirect} from "react-router-dom";

import './index.css';
import logo from '../../assets/img/logoImpulseGreenColor.png';
import foto from '../../assets/images/accountImage.png'
import { setLogout } from '../../redux'
import { client } from '../../client'

function Navigation(props) {
    const handleSignOut = async () => {
        props.handleSignOut();
        localStorage.clear();
        client.cache.reset();
        window.location = "/"
        return (1);
    }

    return(
        <Navbar collapseOnSelect  expand="lg" className="navcolor" variant="pills">
            {/* brand */}
                <Navbar.Brand className="brand m-0 p-0" href="/">
                <img src={logo} alt="logo_impulse"/>
                <span className="impulse">IMPULSE</span>
                </Navbar.Brand>

                <Navbar.Toggle className="hamburger" aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                    <NavCont>
                        {/* <NavItem name={"Pre-Events"} link={"/event"} className="navlink"/> */}
                        <NavItem name={"Events"}>
                            <DropdownMenu></DropdownMenu>
                        </NavItem>
                        {/* <NavItem name={"Merchandise"} link={"/merch"} className="navlink"/> */}
                        <NavItem name={"About"} link={"/about"} className="navlink"/>
                        {props.isLogIn ?
                        <div>
                            <a href="/account"><img src={foto} /></a>
                            <Button variant="flat" size="s" onClick={handleSignOut}
                              >Sign Out</Button>
                        </div>
                        :  <Button variant="flat" size="s" href="/signin"
                        >Sign In</Button>}

                    </NavCont>
                </Navbar.Collapse>
            </Navbar>
    )
}

function NavCont(props) {
    return (
        <Nav className="ml-auto navcont" bg="transparent">
          <ul className="navbar-nav">{props.children}</ul>
        </Nav>
      );
}

function NavItem(props) {
    const [open, setOpen] = useState(false);

    return (
      <li className="nav-item">
        <Nav.Link href={props.link} className="navlink" onClick={() => setOpen(!open)}>
            {props.name}
        </Nav.Link>

        {open && props.children}
      </li>
    );
}

function DropdownMenu() {

    return (
    <ul className="dropdown">
        <li>
            <p>Competition</p>
            <Nav.Link eventKey="1" href="/event/competitionuniv"  className="navDropItem">Universitas</Nav.Link>
            <Nav.Link eventKey="2" className="navDropItem" href="/event/competitionsma">SMA</Nav.Link>
        </li>
        <li>
            <Nav.Link eventKey="3" href="/event/Workshop" className="navDropItem1">Workshop</Nav.Link>
        </li>
        <li>
            <Nav.Link eventKey="4" href="/event/seminar" className="navDropItem1">Seminar</Nav.Link>
        </li>
    </ul>
    )
  }

const mapStateToProps = (state) =>{
    return{
        isLogIn : state.isLogIn
    }
}

const mapDispatchToProps = (dispatch) =>{
    return{
        // handleSignIn : () => dispatch({type : 'LOGIN_TOGGLE'}),
        handleSignOut : () => dispatch(setLogout())
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
